// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3aetp","label":"Radio_label__EQS8R","checkMark":"Radio_checkMark__3Jgzm","disabled":"Radio_disabled__37vbh"};